import { Link } from "react-router-dom";
import {
  FileText,
  LogOut,
  BookOpen,
  UserCheck,
  LayoutDashboard
} from "lucide-react";

const NAV_ITEMS = [
  { path: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { path: "/admin/coach-accounts", label: "Comptes Coachs", icon: UserCheck },
  { path: "/admin/training", label: "Formation", icon: BookOpen },
  { path: "/admin/applications", label: "Candidatures", icon: FileText },
];

const AdminSidebar = ({ sidebarOpen, onClose, user, onLogout, isActive }) => {
  return (
    <aside
      className={`admin-sidebar fixed lg:static inset-y-0 left-0 z-50 transform ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      } lg:translate-x-0 transition-transform`}
    >
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <Link to="/" className="flex items-center gap-2">
          <img
            src="https://customer-assets.emergentagent.com/job_coach-hub-96/artifacts/uwrqhh9u_1777073959823.png"
            alt="APM Logo"
            className="h-10 w-auto invert"
          />
        </Link>
      </div>

      {/* Navigation */}
      <nav className="py-6">
        {NAV_ITEMS.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
            onClick={onClose}
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </Link>
        ))}
      </nav>

      {/* User & Logout */}
      <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-white/10">
        <div className="text-sm text-[#94A3B8] mb-3">{user?.email}</div>
        <button
          onClick={onLogout}
          className="flex items-center gap-2 text-red-500 hover:text-red-400 transition-colors"
          data-testid="admin-logout-button"
        >
          <LogOut className="w-4 h-4" />
          Déconnexion
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
